import { topshotsAPI } from '../../app/api';
import { UserSession } from './login.types';

const loginApi = topshotsAPI.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<UserSession, { email: string; password: string }>({
      query: (request) => ({
        url: 'login',
        method: 'POST',
        body: request,
      }),
    }),
    switchAccount: build.mutation<UserSession, { accountId: string }>({
      query: (request) => ({
        url: 'login/switch',
        method: 'POST',
        body: request,
      }),
    }),
  }),
});

export const { useLoginMutation, useSwitchAccountMutation } = loginApi;
